import { forwardRef } from 'react';

import type { ContainedButtonProps } from '@types';
import { cn } from '@utils';

import { BaseButton } from '.';

export const ContainedButton = forwardRef<HTMLButtonElement, ContainedButtonProps>(
  ({ adornment, onClick, disabled, className, ...props }, ref) => {
    return (
      <BaseButton
        ref={ref}
        className={cn(
          'px-3.5 py-3 rounded-2xl',
          'bg-theme-primary-main text-white',
          'disabled:text-gray-400/30 disabled:bg-gray-200/30',
          className,
        )}
        onClick={onClick}
        adornment={adornment}
        disabled={disabled}
        {...props}
      />
    );
  },
);

ContainedButton.displayName = 'ContainedButton';
